import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { UserAddressesCard } from '../components/CardAddresses';
import { UserCompaniesCard } from '../components/CardCompanies';
import { UserDataCard } from '../components/CardData';
import { UserDocumentsCard } from '../components/CardDocuments';
import { UserPermissionsCard } from '../components/UserPermissionsCard';
import { UserInfoCard } from '../components/CardInfo';
import { UserAttRemarksCard } from '../components/CardUserAttrRemarks';
import { Loader } from '../../../components/Loader';
import { GRANT_PERMISSIONS, KANBAN_PERMISSION_CARD } from '../../../components/Permission/constants';
import { Permission } from '../../../components/Permission';
import { selectUserId, selectWork, selectWorks } from '../../Api/selectors';
import { REQUEST_USER, REQUEST_USER_PROPERTY_UPDATE, REQUEST_WEBSITE_USER } from '../constants';
import { AppClientId } from '../../Shared/constants';
import env from '../../../env';
import { UserKanbanPermissionsCard } from '../components/UserKanbanPermissionsCard';
import { WebsiteLoginPermissionsCard } from '../components/CardWebsiteLoginPermissions';
import LoadingCard from '../../../containers/App/Components/LoadingCard/LoadingCard';

//comment1
const Container = styled.div`
  .card-wrapper {
    width: 98%;
  }
  .user-info-card info-card {
    h2 {
      font-size: 14px;
      text-transform: uppercase;
    }

    &.misc {
      .button {
        margin: 2px;
        background-color: #ddd;
        color: #333;
      }
    }
    width: 98%;
  }

  .vbox.col {
    width: auto;
    @media (max-width: 768px) {
      width: 100%;
      margin: 6px 0;
    }
  }
`;

/* eslint-disable react/prefer-stateless-function */
class UserDetailsColumnsComp extends BaseComponent {
  constructor(props) {
    super(props, {});
  }

  get user() {
    return this.props.user;
  }

  get showPermissionCards() {
    if (!this.user?.azure_id && this.user?.can_login_to_vindat == false) {
      return false;
    }

    return true;
  }

  render() {
    //x
    return (
      <Container>
        <HBox left flip={window.innerWidth <= 768}>
          <VBox left className="col">
            <div className={'card-wrapper'}>
              <UserInfoCard user={this.props.user} />
              <UserDataCard user={this.props.user} />
              {this.props.workWebsiteUser ? <LoadingCard /> : <WebsiteLoginPermissionsCard user={this.props.user} />}
            </div>
          </VBox>
          <VBox left className="col">
            <VBox>
              <div className={'card-wrapper'}>
                <UserCompaniesCard user={this.props.user} />
                <UserAddressesCard user={this.props.user} />

                {this.props.workAttRemarks && env.clientId === AppClientId.AUTOWIENTJES ? (
                  <Loader small />
                ) : (
                  <UserAttRemarksCard user={this.props.user} loggedUserId={this.props.loggedInUserId} />
                )}
                {this.showPermissionCards && (
                  <Permission permission={GRANT_PERMISSIONS}>
                    <UserPermissionsCard user={this.props.user} />
                  </Permission>
                )}
              </div>
            </VBox>
          </VBox>

          <VBox left className="col">
            <UserDocumentsCard user={this.props.user} />

            <Card className="user-info-card info-card misc">
              <h2>other</h2>
              <Permission permission={GRANT_PERMISSIONS}>
                <Button onClick={this.tofn(`/users/${this.user.id}/legacy`)}>{this.lbl('user.details.title')}</Button>
              </Permission>
              <Button onClick={this.tofn(`/users/${this.user.id}/history`)}>Logs</Button>
            </Card>
            {this.showPermissionCards && (
              <Permission permission={[KANBAN_PERMISSION_CARD, GRANT_PERMISSIONS]}>
                <UserKanbanPermissionsCard user={this.props.user} />
              </Permission>
            )}
          </VBox>
        </HBox>
      </Container>
    );
  }
}

UserDetailsColumnsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    workAttRemarks: selectWork(`${REQUEST_USER_PROPERTY_UPDATE}-attRemarks`),
    loggedInUserId: selectUserId(),
    workWebsiteUser: selectWorks([REQUEST_WEBSITE_USER, REQUEST_USER]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserDetailsColumns = compose(withConnect, withRouter)(UserDetailsColumnsComp);
